import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { display } from "@mui/system";

const testimonials = [
  {
    text: "The quality of the stuff I find here is head and shoulders above the others. I'm constantly impressed.",
    author: "Craig J.",
    bgColor: "linear-gradient(135deg, #FFDDE1 0%, #FFB6C1 100%)",
  },
  {
    text: "Fullproof is an absolute godsend. I used to get my products from a local shop but the selection and prices are just so much better here than anywhere else. Thank you!",
    author: "Bridget M.",
    bgColor: "linear-gradient(135deg, #FFF3B0 0%, #FFD700 100%)",
  },
  {
    text: "The experience of shopping on here is so great. Just super reliable and no stress. I'm team fullproof all the way!",
    author: "Alex S.",
    bgColor: "linear-gradient(135deg, #D4FC79 0%, #96E6A1 100%)",
  },
  {
    text: "Everything I’ve bought here worked exactly as expected and even better. Even the new things I’ve tried did not disappoint. Awesome!",
    author: "Jewel K.",
    bgColor: "linear-gradient(135deg, #A1C4FD 0%, #C2E9FB 100%)",
  },
  {
    text: "Buying my product through Fullproof has made shopping so easy! Ordering is a snap and delivery is fast and convenient.",
    author: "Brooks N.",
    bgColor: "linear-gradient(135deg, #D8B4FE 0%, #A78BFA 100%)",
  },
];

const Testimonial = () => {
  const settings = {
    infinite: true,
    centerMode: true,
    centerPadding: "15%",
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: true,
    swipe: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          centerPadding: "0px",
        },
      },
    ],
  };

  return (
    <div style={styles.container}>
      <Slider {...settings}>
        {testimonials.map((testimonial, i) => (
          <div key={i} style={{ ...styles.testimonial }}>
            <div
              style={{
                background: testimonial.bgColor,
                display: "flex",
                height: "100%",
                flexDirection: "column",
                justifyContent: "space-between",
                margin: "0 20px",
                padding: "20px",
                borderRadius: "16px",
                textAlign: "center",
                minHeight: "350px",
              }}
            >
              <div style={{ ...styles.stars }}>★★★★★</div>
              <p style={styles.text}>"{testimonial.text}"</p>
              <span style={styles.author}>{testimonial.author}</span>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    margin: "0 auto",
    padding: "20px 0",
  },
  testimonial: {
    padding: "25px",
    textAlign: "center",
    borderRadius: "16px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    color: "#333",
    fontFamily: "Arial, sans-serif",
    transition: "transform 0.5s ease-in-out",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "hand",
    height: "100%",
    flex: 1,
  },
  stars: {
    fontSize: "1.6rem",
    fontWeight: "bold",
    color: "#111",
    marginBottom: "10px",
  },
  text: {
    fontSize: "1.2rem",
    fontWeight: "600",
    lineHeight: "1.5",
  },
  author: {
    marginTop: "15px",
    fontSize: "1rem",
    fontWeight: "700",
  },
};

export default Testimonial;
